/* global Muuri */

DO.Subscribe('app:ready', (e, $) => {
  function init() {
    const $grid = $('.member-list').isotope({
      itemSelector: '.member-item',
      layoutMode: 'fitRows',
    });

    const filterControls = $('[data-members-list-controls]').children();
    filterControls.on('click', (event) => {
      event.preventDefault();
      $(
        '.taglist-item--current, .taglist-link--current',
        filterControls,
      ).removeClass('taglist-item--current taglist-link--current');
      $(event.target).addClass('taglist-link--current');
      $(event.target).parent().addClass('taglist-item--current');
      $(event.target)
        .parents('.taglist-wrapper')
        .children('.taglist-trigger')
        .click();
      const filter = $(event.target).parent().data('filter');

      $grid.isotope({
        filter: (key, item) => {
          const categories = $(item).data('categories');
          return filter === 'all'
            ? true
            : categories.indexOf(filter) > -1;
        },
      });
    });
  }

  init();
});

const urlParser = {
  getParam(href, param) {
    const reg = new RegExp(`${param}=([^&]+)`);
    const member = href.match(reg);
    return member ? member[1] : null;
  },
  updateParam(href, param, value) {
    const reg = new RegExp(`${param}[^&]+`);
    const hasParam = !!href.match(param);

    const operator = href.indexOf('?') < 0 ? '?' : '&';

    href = hasParam
      ? href.replace(reg, `${param}=${value}`)
      : `${href}${operator}${param}=${value}`;

    return this.cleanHref(href);
  },
  removeParam(href, param) {
    const reg = new RegExp(`${param}[^&]+[&]?`);
    href = href.replace(reg, '');
    return this.cleanHref(href);
  },
  cleanHref(href) {
    href = href.replace(/\?\?/g, '?');
    // href = href.replace(/(?<=\?.+)(\?)/g, "");
    // href = href.replace(/(?:\/)([^#]+)(?=#|$)/, "");
    href = href.replace(/&&/g, '&');
    return href.replace(/(|&|\?)$/g, '');
  },
};

DO.Subscribe('app:ready', (e, $) => {
  const MEMBER_PARAM = 'staff';

  function openModal(member) {
    // Extract info from data-* attributes
    const image = member.data('image');
    const name = member.data('name');
    const jobTitle = member.data('job-title');
    const email = member.data('email');
    const summary = member.data('summary');
    const linkedin = member.data('linkedin');
    const modal = $('#member-modal');
    const iwiAttribution = member.data('iwi-attribution');
    const pronouns = member.data('pronouns');

    modal.find('.modal-image').attr({
      src: image,
      alt: name,
    });
    modal.find('.modal-title').text(name);
    modal.find('.modal-text').html(summary);
    modal.find('.member-modal-job-title').text(jobTitle);
    modal.find('.member-modal-email').text(email);
    modal.find('.member-modal-iwi-attribution').text(iwiAttribution);
    modal.find('.member-modal-title').append(` <span class="member-modal-pronouns">${pronouns}</span>`);

    return linkedin
      ? modal
        .find('.member-modal-linkedin')
        .html(
          `<a class="member-modal-linkedin-url" href="${linkedin}" target="_blank"><span class="sr-only">Go to ${linkedin}</span></a>`,
        )
      : modal.find('.member-modal-linkedin').empty();
  }

  function onCloseModal() {
    const url = urlParser.removeParam(
      window.location.href,
      MEMBER_PARAM,
    );
    const hasMemberInUrl = !!urlParser.getParam(
      window.location.href,
      MEMBER_PARAM,
    );

    if (hasMemberInUrl) {
      window.history.pushState({}, '', url);
    }
  }

  function addToHistory(urlName) {
    const url = urlParser.updateParam(
      window.location.href,
      MEMBER_PARAM,
      urlName,
    );
    window.history.pushState({}, '', url);
  }

  function onMemberClick(event) {
    const member = $(event.relatedTarget);
    const urlName = member.data('url-name');
    const browserUrlName = urlParser.getParam(
      window.location.href,
      MEMBER_PARAM,
    );
    const openFromUrl = browserUrlName === urlName && browserUrlName !== '';

    if (!openFromUrl) {
      addToHistory(urlName);
    }

    openModal(member);
  }

  function onUrlChange() {
    const browserUrlName = urlParser.getParam(
      window.location.href,
      MEMBER_PARAM,
    );

    $('#member-modal').modal('hide');

    if (browserUrlName) {
      $(`[data-url-name='${browserUrlName}']`).click();
    }
  }

  function bindEvents() {
    $('#member-modal').on('show.bs.modal', (event) => {
      onMemberClick(event);
    });

    $('#member-modal').on('hide.bs.modal', (event) => {
      onCloseModal();
    });

    $(window).on('popstate', (event) => {
      onUrlChange();
    });
  }

  function init() {
    bindEvents();
    onUrlChange();
  }

  init();
});
